import { render, staticRenderFns } from "./CourseView.vue?vue&type=template&id=362777ef&"
import script from "./CourseView.vue?vue&type=script&lang=js&"
export * from "./CourseView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports